import { ComponentStyleConfig } from '@chakra-ui/react';

export const Card: ComponentStyleConfig = {
  baseStyle: {
    container: {
      backgroundColor: 'M.10',
    },
  },
};
